export default "__VITE_ASSET__CpBI3Fin__"